import React, { useCallback, useState } from 'react';
import Button from '../../../components/common/Button/Button';
import Icon from '../../../components/common/Icon/Icon';
import styles from './CheckoutCopyField.module.css';

interface CheckoutCopyFieldProps {
  label: string;
  value: string;
  copyLabel?: string;
  monospace?: boolean;
  multiline?: boolean;
}

const CheckoutCopyField: React.FC<CheckoutCopyFieldProps> = ({
  label,
  value,
  copyLabel = 'Copiar',
  monospace = true,
  multiline = false,
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(async () => {
    if (!value.trim()) {
      return;
    }

    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  }, [value]);

  const handleSelectAll = useCallback((event: React.MouseEvent<HTMLTextAreaElement>) => {
    event.preventDefault();
    event.currentTarget.focus();
    event.currentTarget.select();
  }, []);

  return (
    <div className={styles.field}>
      <div className={styles.header}>
        <span className={styles.label}>{label}</span>
        <Button
          type="button"
          variant="ghost"
          size="small"
          onClick={handleCopy}
          disabled={!value.trim()}
          className={styles.copyButton}
        >
          <Icon name={copied ? 'check' : 'content_copy'} size={16} aria-hidden />
          {copied ? 'Copiado!' : copyLabel}
        </Button>
      </div>
      <textarea
        readOnly
        rows={multiline ? 4 : 3}
        value={value || '—'}
        aria-label={label}
        className={`${styles.value} ${monospace ? styles.monospace : ''} ${multiline ? styles.multiline : ''}`.trim()}
        onMouseDown={handleSelectAll}
        onFocus={(event) => event.currentTarget.select()}
      />
    </div>
  );
};

export default CheckoutCopyField;
